import { Link, useRouterState } from '@tanstack/react-router'

const Error404 = () => {
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  })

  return (
    <div className="relative h-full min-h-full w-full overflow-hidden bg-auth-page">
      <div className="pointer-events-none absolute inset-0 bg-auth-radial" />
      <div className="relative flex h-full min-h-full items-center justify-center px-4 py-10 sm:px-6">
        <div className="w-full max-w-[560px]">
          <div className="mb-8 text-center">
            <h1 className="text-[40px] font-semibold leading-tight text-auth-title sm:text-[44px]">
              Page not found
            </h1>
            <p className="mt-2 text-lg text-auth-muted">
              We could not match this URL to a valid route.
            </p>
            <span className="mt-4 inline-block rounded-md border border-auth-input-border bg-auth-input-bg px-3 py-1 text-sm text-auth-subtle">
              {pathname}
            </span>
          </div>

          <img
            src="/assets/images/404.svg"
            alt="Page not found"
            className="mx-auto w-full max-w-[360px] object-contain"
          />

          <div className="mt-8 flex justify-center">
            <Link
              to="/"
              className="inline-flex h-11 min-w-40 items-center justify-center rounded-lg border border-auth-button-border bg-auth-button-bg px-6 text-base font-medium text-auth-button-text transition-colors hover:bg-auth-button-hover"
            >
              Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Error404
